<template>
    <div class="tw-relative">
        <svg :viewBox="`0 0 ${W} ${H}`" preserveAspectRatio="none" class="tw-w-full" :style="{ height: height + 'px' }">
            <line v-for="(gy, i) in gridYs" :key="'g' + i" :x1="0" :x2="W" :y1="gy" :y2="gy" stroke="#e5e7eb" stroke-width="1" />
            <g v-for="(it, i) in items" :key="i">
                <rect :x="barX(i)" :y="barY(it.value)" :width="barW" :height="barH(it.value)" rx="4"
                    :fill="color" :opacity="hoverIndex === i ? 1 : 0.85"
                    class="tw-duration-150 tw-cursor-pointer"
                    @mouseenter="hoverIndex = i" @mouseleave="hoverIndex = null" />
            </g>
        </svg>
        <div class="tw-flex tw-justify-between tw-mt-1" :style="{ paddingLeft: gap + 'px', paddingRight: gap + 'px' }">
            <span v-for="(it, i) in items" :key="'l' + i" class="tw-text-[10px] tw-text-gray-400 tw-flex-1 tw-text-center">{{ it.label }}</span>
        </div>

        <div v-if="hoverIndex !== null" class="tw-absolute tw-pointer-events-none tw-z-10 tw-bg-gray-900 tw-text-white tw-text-xs tw-rounded-lg tw-px-3 tw-py-1.5 tw-shadow-lg"
            :style="tooltipStyle">
            <span class="tw-font-semibold">{{ items[hoverIndex].label }}:</span> {{ items[hoverIndex].value }}
        </div>
    </div>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';

const props = defineProps({
    items: { type: Array, default: () => [] }, // [{ label, value }]
    color: { type: String, default: '#8b5cf6' },
    height: { type: Number, default: 200 },
});

const W = 600, H = 200;
const padT = 10, padB = 4;
const hoverIndex = ref(null);

const n = computed(() => props.items.length || 1);
const gap = computed(() => (W / n.value) * 0.28);
const slot = computed(() => W / n.value);
const barW = computed(() => slot.value - gap.value * 2);
const maxVal = computed(() => Math.max(1, ...props.items.map(i => i.value)));

const barX = (i) => i * slot.value + gap.value;
const barH = (v) => (Math.max(0, v) / maxVal.value) * (H - padT - padB);
const barY = (v) => H - padB - barH(v);

const gridYs = computed(() => [0, 0.5, 1].map(t => padT + (H - padT - padB) * t));

const tooltipStyle = computed(() => {
    const frac = (hoverIndex.value + 0.5) / n.value;
    const left = frac * 100;
    return { left: `${left}%`, top: '0px', transform: `translateX(${left > 75 ? '-100%' : left < 25 ? '0' : '-50%'})` };
});
</script>
